import React, { useState } from 'react';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import { Label, Input } from 'reactstrap';
import { Link } from 'react-router-dom';

function TosModal(props) {
  const [disableBtn, setDisableBtn] = useState(true);
  const [showModal, setShowModal] = useState(props.modal);

  const toggleCheckbox = e => {
    setDisableBtn(!e.target.checked);
  };

  const proceed = () => {
    props.onConfirm();
    setShowModal(false);
  };

  let tosLink = (
    <Link to="/termsofuse" target="_blank">
      Terms of Use
    </Link>
  );
  if (props.client && props.client.indexOf('permitium') >= 0) {
    tosLink = (
      <Link to="/termsofuseperm" target="_blank">
        Terms of Use
      </Link>
    );
  }
  if (props.client && props.client.indexOf('archive') >= 0) {
    tosLink = (
      <Link to={`/termsofusearchive/${props.districtName}`} target="_blank">
        Terms of Use
      </Link>
    );
  }
  return (
    <Modal isOpen={showModal}>
      <ModalBody>
        <div style={{ textAlign: 'center' }}>
          <Label check>
            <Input type="checkbox" name="accept" onChange={toggleCheckbox} /> I
            accept the {tosLink}
          </Label>
        </div>
      </ModalBody>
      <ModalFooter>
        <button
          className="btn btn-success"
          onClick={proceed}
          disabled={disableBtn}
        >
          Proceed
        </button>
      </ModalFooter>
    </Modal>
  );
}

export default TosModal;
